<template>
  <div class="container">
    <!-- 功能 -->
    <div class="table-container">
      <div class="table-action-row">
        <div class="table-action-form">
          <el-input
            class="form-item"
            v-model="aiAgentForm.name"
            clearable
            placeholder="请输入名称进行检索"
            @input="handleInput"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>
          <el-select
            class="form-item"
            v-model="aiAgentForm.type"
            placeholder="请选择应用类型"
            @change="refresh"
            clearable
          >
            <el-option
              v-for="obj in appList"
              :key="obj.label"
              :label="obj.label"
              :value="obj.value"
            ></el-option>
          </el-select>
          <el-button @click="handleReset">重 置</el-button>
        </div>
        <div class="table-action-button">
          <el-button
            v-if="jurisdiction.aiAgentAppManagement_agent_create"
            type="primary"
            @click="add()"
          >
            新建
          </el-button>
        </div>
      </div>
      <List ref="list" :request="getList" :layout="layout">
        <template v-slot:table-action>
          <el-table-column fixed="right" label="操作" width="400">
            <template slot-scope="scope">
              <el-button
                v-if="jurisdiction.aiAgentAppManagement_agent_edit"
                class="text-button"
                type="text"
                @click="edit(scope.row)"
              >
                编辑
              </el-button>
              <el-button class="text-button" type="text" @click="toFlow(scope.row)">
                流程编排
              </el-button>
              <el-button
                v-if="jurisdiction.aiAgentAppManagement_agent_release"
                class="text-button"
                type="text"
                @click="publish(scope.row)"
              >
                发布
              </el-button>
              <el-button
                v-if="jurisdiction.aiAgentAppManagement_agent_delete"
                class="text-button"
                type="text"
                @click="toDelete(scope.row, scope.$index)"
              >
                删除
              </el-button>
              <!-- <el-dropdown trigger="click" placement="bottom">
                <el-button type="text">
                  <i class="iconfont icon-more" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="exportJSON(scope.row)">导出</el-dropdown-item>
                  <el-dropdown-item
                    class="danger-action"
                    @click.native="del(scope.row, scope.$index)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </template>
      </List>
      <createAgentApp
        :visible="createVisible"
        @close="createVisible = false"
        :row="rowMessage"
        @refresh="refresh"
      />
      <editAgentApp
        :visible="detailVisible"
        @close="detailVisible = false"
        :row="rowMessage"
        @refresh="refresh"
      />
    </div>
    <messageBox ref="messageBox" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '@/components/table';
import messageBox from '@/components/messageBox';
import editAgentApp from './components/editAgentApp.vue';
import createAgentApp from './components/createAgentApp.vue';
import _ from 'lodash';

export default {
  components: {
    List,
    messageBox,
    editAgentApp,
    createAgentApp,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      tabList: [
        { name: '1', label: '已启用' },
        { name: '2', label: '已停用' },
      ],
      // 搜索表单
      aiAgentForm: {
        name: '',
        type: '',
      },
      appList: [
        {
          label: 'chatflow',
          value: 'chatflow',
        },
        {
          label: 'workflow',
          value: 'workflow',
        },
      ],
      layout: [
        { name: 'id', label: '唯一编码' },
        { name: 'name', label: '应用名称' },
        { name: 'description', label: '描述' },
        { name: 'type', label: '应用类型' },
        // { name: 'graph', label: '发布的流程配置' },
        // { name: 'graph_draft', label: '草稿流程配置' },
        { name: 'is_system', label: '是否系统应用' },
        { name: 'version', label: '版本号' },
      ],
      createVisible: false,
      detailVisible: false,
      rowMessage: {
        id: '',
        name: '',
        description: '',
        type: '',
        graph: '',
        graph_draft: '',
        is_system: true,
        version: '',
      },
      // // 新建窗口展示
      // basicInfoVisable: false,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      // this.getElementList
      console.log('%c Line:154 🍷 this.getElementList', 'color:#4fff4B', this.getElementList);
      const jurisdictionArray = [
        'aiAgentAppManagement_agent_edit',
        'aiAgentAppManagement_agent_release',
        'aiAgentAppManagement_agent_delete',
        'aiAgentAppManagement_agent_create',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      console.log('%c Line:167 🍷 jurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },

    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      // pageIndex, pageSize
      console.log('%c Line:188 🍒 pageIndex, pageSize', 'color:#7f2b82', pageIndex, pageSize);
      const params = {
        offset: (pageIndex - 1) * pageSize,
        limit: pageSize,
      };
      if (this.aiAgentForm.name) {
        params.name = this.aiAgentForm.name;
      }
      if (this.aiAgentForm.type) {
        params.type = this.aiAgentForm.type;
      }
      return this.$request({
        url: this.$api.getAiListAgentApps,
        data: params,
      }).then((res) => {
        // res
        console.log('%c Line:162 🍎 res', 'color:#7f2b82', res);
        const list = res?.agent_apps || [];

        const computedList = list.map((item) => ({
          ...item,
          is_system: item.is_system ? '是' : '否',
        }));
        return {
          list: computedList,
          total: res?.total_count || 0,
        };
      });
    },

    // 表单查询
    handleInput: _.debounce(function () {
      this.refresh();
    }, 1000),

    handleReset() {
      this.aiAgentForm.name = '';
      this.aiAgentForm.type = '';
      this.refresh();
    },

    // 增删改
    add() {
      this.createVisible = true;
    },

    edit(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    toFlow(row) {
      this.$router.push({
        name: 'ai-flow-nodes',
        query: {
          id: row.id,
        },
      });
    },

    publish({ id, version }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定发布该AgentApp吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.publishAgentApp,
            data: { id, version },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },

    toDelete({ id }) {
      this.$refs.messageBox.show({
        title: '提示',
        content: '确定删除该数据吗?',
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteAgentAppById,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';

.container {
  display: flex;
  flex-direction: column;
}
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
.table-container {
  flex: 1;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
  .table-action-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    .table-action-form {
      display: flex;
      .form-item {
        width: 240px;
        margin-right: 8px;
      }
    }
  }
  .text-button {
    margin-right: 15px;
  }
  .danger-action {
    color: #e34d59;
  }
}
</style>
